import { Navbar } from "@/components/Navbar";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from "@/components/ui/breadcrumb";

const TechnologyCaseStudies = () => {
  const caseStudies = [
    {
      id: "tech-1",
      company: "CloudTech Solutions",
      title: "Cloud Infrastructure Optimization",
      summary: "How we helped reduce cloud costs by 40% while improving performance",
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
      path: "/case-studies/technology/cloudtech-solutions"
    },
    {
      id: "tech-2",
      company: "DataFlow Analytics",
      title: "AI-Powered Analytics Platform",
      summary: "Implementing machine learning to transform data processing",
      image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6",
      path: "/case-studies/technology/dataflow-analytics"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <Navbar />
      
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <Breadcrumb className="mb-8">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="/case-studies">Case Studies</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink>Technology</BreadcrumbLink>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-blue-900 mb-4">
            Technology Success Stories
          </h1>
          <p className="text-xl text-blue-700/80 max-w-2xl mx-auto">
            Discover how we've helped technology companies innovate and scale their operations
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {caseStudies.map((study) => (
            <Link key={study.id} to={study.path}>
              <Card className="group overflow-hidden transition-all duration-300 hover:shadow-xl">
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={study.image}
                    alt={study.company}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-blue-900/40 group-hover:bg-blue-900/30 transition-colors" />
                </div>
                <CardContent className="p-6">
                  <h2 className="text-2xl font-semibold text-blue-900 mb-2 group-hover:text-blue-700">
                    {study.company}
                  </h2>
                  <h3 className="text-xl text-blue-800 mb-3">
                    {study.title}
                  </h3>
                  <p className="text-blue-700/80 mb-4">
                    {study.summary}
                  </p>
                  <div className="flex items-center text-blue-600 font-medium">
                    Read Case Study
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechnologyCaseStudies;